import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleNotification";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import { wipsScreenStatusOptions } from "../../shared/utility";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function WipsViewModel(logout) {
  const defaultFilters = {
    room: { value: -1, label: "All rooms" },
    status: { value: 0, label: "Open" },
    startDate: null,
    endDate: null,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [wips, setWips] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [rooms, setRooms] = useState([]);

  const getWips = async function (search, page, filter = filters) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filter: filter,
    };
    let callResult = await makePostApiCall(`wips`, payload);

    if (callResult.success) {
      const response = callResult.data;
      if (page > 1) {
        setWips({ ...response, data: [...wips.data, ...response.data] });
      } else {
        setLoading(false);
        setWips(response);
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const deleteWip = async function (wipId) {
    let callResult = await makePostApiCall(`deleteWip/${wipId}`, {});
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getWips(null, 0, filters);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteWip = function (wip) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteWip(wip.id)}
          message={`Are you sure you want to delete wip ${wip.lot_number}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() =>
        setFilters({
          ...filters,
          startDate: null,
          endDate: null,
        })
      }
    />,
    <FilterSingleSelectDropdown
      header="Room"
      onChange={(value) =>
        setFilters({
          ...filters,
          room: value,
        })
      }
      options={rooms}
      resetFilter={() =>
        setFilters({
          ...filters,
          room: { value: -1, label: "All rooms" },
        })
      }
      valueName="room"
      value={filters.room}
    />,
    <FilterSingleSelectDropdown
      header="Status"
      onChange={(value) =>
        setFilters({
          ...filters,
          status: value,
        })
      }
      options={wipsScreenStatusOptions}
      resetFilter={() =>
        setFilters({
          ...filters,
          status: { value: 0, label: "Open" },
        })
      }
      valueName="status"
      value={filters.status}
    />,
  ];

  const resetFilters = () => {
    setFilters(defaultFilters);

    setShowFilters(false);
    getWips(null, 1, defaultFilters);
  };

  const getRooms = async function () {
    let callResult = await makeGetApiCall(`roomsForDropdown`);
    if (callResult.success) {
      setRooms(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    askDeleteWip,
    emptyModal,
    getWips,
    loading,
    wips,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    showFilters,
    setShowFilters,
    filters,
    filterComponents,
    resetFilters,
    getRooms,
  };
}
